import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Pause, Play } from 'lucide-react';

const Testimonials = () => {
const [currentIndex, setCurrentIndex] = useState(0);
const [isAutoPlaying, setIsAutoPlaying] = useState(true);
const [touchStart, setTouchStart] = useState(null);
const [touchEnd, setTouchEnd] = useState(null);
const [isMobile, setIsMobile] = useState(false);
const [imageErrors, setImageErrors] = useState({});

// Check if mobile on mount and window resize
useEffect(() => {
const checkIsMobile = () => {
setIsMobile(window.innerWidth < 768);
};

checkIsMobile();
window.addEventListener('resize', checkIsMobile);

return () => window.removeEventListener('resize', checkIsMobile);
}, []);

const originalTestimonials = [
{
name: "Daisy Gomez",
avatar: "/testimonials/Daisy.webp",
quote: "Heather (HT) she is the best trainer coach I've ever had! She is so knowledgeable in everything training and working out! She is 4x certified! I was the person that has never worked out and she turned me into a phytness lover! Slowly but surely. She focuses on all things woman phyness! If you don't know where to start.. it is here!!!",
highlight: "Found Perfect Coach",
rating: 5.0
},
{
name: "Meredith Smith",
avatar: "/testimonials/Meredith.webp",
quote: "I have been a client of Heather since 2017. From her bootcamp days to her current about the PHYT, Heather's growth and expertise has been amazing. Using her weight loss regimen, I was able to lose 25 pounds. After 3 years, I'm still maintaining the weight loss.",
highlight: "Lost 25 lbs",
rating: 5.0
},
{
name: "Ribkah N",
avatar: "/testimonials/Ribkah.webp",
quote: "Heather is INCREDIBLE! I've been working with her for two months and the changes are extraordinary - my mobility, flexibility, and strength have progressed so much. Heather truly cares about her clients and is always going to put your safety first and support you in building a strong foundation.",
highlight: "Improved Mobility",
rating: 5.0
},
{
name: "J S",
avatar: "/testimonials/JS.webp",
quote: "Love love love the Phyt Gym! Been a member since 2021 and got a whole new shape through Coach HT's fitness and diet programs. HT focuses on safety first, making weight training doable for all without injury. I've done both individual coaching and small group training - you can't go wrong with either.",
highlight: "Transformed Body",
rating: 5.0
}
];

// Create infinite loop by duplicating testimonials
const testimonials = [...originalTestimonials, ...originalTestimonials, ...originalTestimonials];

// Auto-play functionality
useEffect(() => {
if (isAutoPlaying) {
const timer = setInterval(() => {
setCurrentIndex((prevIndex) => {
  const nextIndex = prevIndex + 1;
  // Reset to original testimonials when reaching the end
  if (nextIndex >= originalTestimonials.length) {
    return 0;
  }
  return nextIndex;
});
}, 5000); // Change slide every 5 seconds

return () => clearInterval(timer);
}
}, [isAutoPlaying, originalTestimonials.length]);

const nextSlide = () => {
setCurrentIndex((prevIndex) => {
  const nextIndex = prevIndex + 1;
  // Reset to original testimonials when reaching the end
  if (nextIndex >= originalTestimonials.length) {
    return 0;
  }
  return nextIndex;
});
};

const prevSlide = () => {
setCurrentIndex((prevIndex) => {
  const prevIndexValue = prevIndex - 1;
  // Loop to the end when going backwards from the beginning
  if (prevIndexValue < 0) {
    return originalTestimonials.length - 1;
  }
  return prevIndexValue;
});
};

const goToSlide = (index) => {
setCurrentIndex(index);
};

const toggleAutoPlay = () => {
setIsAutoPlaying(!isAutoPlaying);
};

// Touch handlers for swipe functionality
const minSwipeDistance = 50;

const onTouchStart = (e) => {
setTouchEnd(null);
setTouchStart(e.targetTouches[0].clientX);
};

const onTouchMove = (e) => {
setTouchEnd(e.targetTouches[0].clientX);
};

const onTouchEnd = () => {
if (!touchStart || !touchEnd) return;

const distance = touchStart - touchEnd;
const isLeftSwipe = distance > minSwipeDistance;
const isRightSwipe = distance < -minSwipeDistance;

if (isLeftSwipe) {
nextSlide();
} else if (isRightSwipe) {
prevSlide();
}
};

// Handle image error
const handleImageError = (index) => {
setImageErrors(prev => ({ ...prev, [index]: true }));
};

// Get initial from name
const getInitial = (name) => {
return name.split(' ').map(n => n[0]).join('').toUpperCase();
};

// Get random color for avatar background
const getAvatarColor = (name) => {
const colors = [
'bg-purple-500',
'bg-primary-500', 
'bg-pink-500',
'bg-indigo-500',
'bg-teal-500',
'bg-orange-500',
'bg-red-500',
'bg-green-500'
];
const index = name.charCodeAt(0) % colors.length;
return colors[index];
};

return (
<section className="py-16 bg-gradient-to-br from-primary-50 to-purple-50" id="testimonials">
<div className="max-w-7xl mx-auto px-4">
<div className="text-center mb-12">
<h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
Real Results, <span className="bg-gradient-to-r from-primary-500 to-primary-600 bg-clip-text text-transparent">Real Stories</span>
</h2>
<p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
See what our community has achieved with the PHYT method
</p>

{/* Play/Pause Control */}
<div className="flex justify-center items-center gap-4 mb-8">
<button
  onClick={toggleAutoPlay}
  className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 text-primary-500 border border-primary-200"
>
  {isAutoPlaying ? (
    <>
      <Pause size={16} />
      <span className="text-sm font-medium">Pause</span>
    </>
  ) : (
    <>
      <Play size={16} />
      <span className="text-sm font-medium">Play</span>
    </>
  )}
</button>
</div>
</div>

<div className="relative">
{/* Navigation arrows */}
<button
onClick={prevSlide}
className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg hover:shadow-xl p-3 rounded-full text-primary-500 hover:bg-primary-50 transition-all duration-300 hidden md:flex items-center justify-center"
>
<ChevronLeft size={24} />
</button>

<button
onClick={nextSlide}
className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg hover:shadow-xl p-3 rounded-full text-primary-500 hover:bg-primary-50 transition-all duration-300 hidden md:flex items-center justify-center"
>
<ChevronRight size={24} />
</button>

{/* Testimonial Cards Container */}
<div 
className="overflow-hidden"
onTouchStart={onTouchStart}
onTouchMove={onTouchMove}
onTouchEnd={onTouchEnd}
>
<div 
  className="flex transition-transform duration-500 ease-in-out"
  style={{ 
    transform: `translateX(-${currentIndex * (isMobile ? 80 : 100/3)}%)`,
  }}
>
  {testimonials.map((testimonial, index) => (
    <div
      key={index}
      className="w-4/5 md:w-1/3 flex-shrink-0 px-2"
    >
      <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 md:p-8 h-full flex flex-col transform hover:-translate-y-1">
        {/* Rating */}
        <div className="flex justify-center mb-4">
          <div className="flex items-center gap-2">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <Star key={i} fill="currentColor" size={16} className="md:w-[18px] md:h-[18px]" />
              ))}
            </div>
            <span className="text-sm font-medium text-gray-600">({testimonial.rating})</span>
          </div>
        </div>

        {/* Avatar */}
        <div className="flex justify-center mb-4 md:mb-6">
          {testimonial.avatar && !imageErrors[index] ? (
            <img 
              src={testimonial.avatar} 
              alt={testimonial.name}
              className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover ring-4 ring-primary-100 shadow-lg"
              onError={() => handleImageError(index)}
            />
          ) : (
            <div className={`w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center text-white font-bold text-lg md:text-xl ring-4 ring-primary-100 shadow-lg ${getAvatarColor(testimonial.name)}`}>
              {getInitial(testimonial.name)}
            </div>
          )}
        </div>
        
        {/* Highlight Quote */}
        <h3 className="text-base md:text-lg font-bold text-primary-500 mb-3 md:mb-4 text-center leading-tight">
          {testimonial.highlight}
        </h3>
        
        {/* Full Quote */}
        <blockquote className="text-gray-600 text-sm leading-relaxed mb-4 md:mb-6 flex-grow">
          "{testimonial.quote}"
        </blockquote>
        
        {/* Name */}
        <div className="text-center">
          <div className="font-bold text-gray-900 md:text-lg">
            {testimonial.name}
          </div>
          <div className="text-sm text-gray-500">PHYT Client</div>
        </div>
      </div>
    </div>
  ))}
</div>
</div>

{/* Mobile Carousel - Show one card at 80% width */}
<div className="md:hidden">

</div>
</div>

{/* Dots Navigation */}
<div className="flex justify-center mt-8 space-x-2">
{originalTestimonials.map((_, index) => (
<button
  key={index}
  onClick={() => goToSlide(index)}
  className={`w-3 h-3 rounded-full transition-all duration-300 ${
    index === currentIndex 
      ? 'bg-primary-500 w-8' 
      : 'bg-primary-200 hover:bg-primary-300'
  }`}
/>
))}
</div>

{/* Mobile Navigation Buttons */}
<div className="flex justify-center mt-6 gap-4 md:hidden">
<button
onClick={prevSlide}
className="bg-white shadow-lg p-3 rounded-full text-primary-500 hover:bg-primary-50 transition-all duration-300"
>
<ChevronLeft size={20} />
</button>
<button
onClick={nextSlide}
className="bg-white shadow-lg p-3 rounded-full text-primary-500 hover:bg-primary-50 transition-all duration-300"
>
<ChevronRight size={20} />
</button>
</div>
</div>
</section>
);
};

export default Testimonials;